import axios from "axios";

// Create an instance of axios with a base URL
const instance = axios.create({
  baseURL: process.env.REACT_APP_baseURL,
});

export default instance;
